export const CANCEL_TX = 'CANCEL'



// WEBPACK FOOTER //
// ./src/components/AppConfirmationDialog/constants.js